const radioColors: object = {
  "blue-gray": {
    color: "text-blue-gray-500",
    border: "checked:border-blue-gray-500",
    before: "checked:before:bg-blue-gray-500",
  },
  gray: {
    color: "text-gray-500",
    border: "checked:border-gray-500",
    before: "checked:before:bg-gray-500",
  },
  brown: {
    color: "text-brown-500",
    border: "checked:border-brown-500",
    before: "checked:before:bg-brown-500",
  },
  "deep-orange": {
    color: "text-deep-orange-500",
    border: "checked:border-deep-orange-500",
    before: "checked:before:bg-deep-orange-500",
  },
  orange: {
    color: "text-orange-500",
    border: "checked:border-orange-500",
    before: "checked:before:bg-orange-500",
  },
  amber: {
    color: "text-amber-500",
    border: "checked:border-amber-500",
    before: "checked:before:bg-amber-500",
  },
  yellow: {
    color: "text-yellow-500",
    border: "checked:border-yellow-500",
    before: "checked:before:bg-yellow-500",
  },
  lime: {
    color: "text-lime-500",
    border: "checked:border-lime-500",
    before: "checked:before:bg-lime-500",
  },
  "light-green": {
    color: "text-light-green-500",
    border: "checked:border-light-green-500",
    before: "checked:before:bg-light-green-500",
  },
  green: {
    color: "text-green-500",
    border: "checked:border-green-500",
    before: "checked:before:bg-green-500",
  },
  teal: {
    color: "text-teal-500",
    border: "checked:border-teal-500",
    before: "checked:before:bg-teal-500",
  },
  cyan: {
    color: "text-cyan-500",
    border: "checked:border-cyan-500",
    before: "checked:before:bg-cyan-500",
  },
  "light-blue": {
    color: "text-light-blue-500",
    border: "checked:border-light-blue-500",
    before: "checked:before:bg-light-blue-500",
  },
  blue: {
    color: "text-blue-500",
    border: "checked:border-blue-500",
    before: "checked:before:bg-blue-500",
  },
  indigo: {
    color: "text-indigo-500",
    border: "checked:border-indigo-500",
    before: "checked:before:bg-indigo-500",
  },
  "deep-purple": {
    color: "text-deep-purple-500",
    border: "checked:border-deep-purple-500",
    before: "checked:before:bg-deep-purple-500",
  },
  purple: {
    color: "text-purple-500",
    border: "checked:border-purple-500",
    before: "checked:before:bg-purple-500",
  },
  pink: {
    color: "text-pink-500",
    border: "checked:border-pink-500",
    before: "checked:before:bg-pink-500",
  },
  red: {
    color: "text-red-500",
    border: "checked:border-red-500",
    before: "checked:before:bg-red-500",
  },
};

export default radioColors;
